import { sendBackendPagination } from "../../common/utils/pagination";
import { ITransactionFilterDto } from "../../interfaces/filters/ITransactionFilterDto";
import { IListPagination } from "../../interfaces/pagination/IListPagination";
import { IPagination } from "../../interfaces/pagination/IPagination";
import { ITransactionDto } from "../../interfaces/transaction/ITransactionDto";
import { cryptoPortfolioService } from "../httpService/cryptoPorfolio.service";

export async function tryGetTransactionListPaginated(pagination: IPagination, filters: ITransactionFilterDto) {
    return await cryptoPortfolioService.post<IListPagination<ITransactionDto>>(
        `/transaction/gettransactionlistpaginated?page=${sendBackendPagination(pagination.page)}&pageSize=${pagination.rowsPerPage}`,
        filters
    )
}

export async function tryGetTransanctionById(transactionId: string) {
    return await cryptoPortfolioService.get<ITransactionDto>(`/transaction/getbyid/${transactionId}`);
}

export async function tryCreateTransaction(transaction: ITransactionDto) {
    return await cryptoPortfolioService.post('/transaction/create', transaction);
}

export async function tryUpdateTransaction(transaction: ITransactionDto) {
    return await cryptoPortfolioService.put('/transaction/update', transaction);
}

export async function tryDeleteTransaction(transactionId: string) {
    return await cryptoPortfolioService.delete(`/transaction/delete/${transactionId}`);
}